/**
 * Deze niet-react klasse is een wrapper om het logboek
 *
 * @history
 * 1 augustus 2022
 * storeLogboek
 *
 * 21 juli 2022
 * Start implementatie
 *
 */

export class Logboek
{
    constructor()
    {
        this.logboek = {};
        this.id = -1;
        this.access_id2 = -1;
        this.access_id1 = -1;
        this.session_fields =
            {
                multiple_group_divisions: 'N',
                multiple_instructions: 'N',
                multiple_rounds: 'N',
                student_mode: 'teacher',
                current_round: 0,
                round_status: 'closed'
            }
    }

    hasField(p_field)
    {
        return this.logboek.hasOwnProperty(p_field);
    }

    getSessionField(p_field)
    {
        return this.session_fields[p_field];
    }

    updateSessionField(p_field, p_value)
    {
        this.session_fields[p_field] = p_value;
    }

    getField(p_field)
    {
        if (this.hasField(p_field))
        {
            console.log(this.logboek[p_field]);
            return this.logboek[p_field];
        }
        return "";
    }

    updateField(p_field, p_value)
    {
        this.logboek[p_field] = this.stripHTML(p_value);
    }

    stripHTML(p_string)
    {
        var regX = /(<([^>]+)>)/ig;
        var str = p_string.toString();

        return str.replace(regX, '');
    }

    getLogboek()
    {
        return JSON.parse(JSON.stringify(this.logboek)); // hierdoor altijd een kopie
    }

    setLogboek(p_id, p_access_id1, p_access_id2, p_session_fields, p_logboek)
    {
        this.id = p_id;
        this.access_id1 = p_access_id1;
        this.access_id2 = p_access_id2;

        let self = this;

        ["multiple_group_divisions", "multiple_instructions", "multiple_rounds", "student_mode", "current_round", "round_status"].forEach(function (key)
        {
            self.session_fields[key] = p_session_fields[key];
        });

        this.logboek = JSON.parse(JSON.stringify(p_logboek)); // hierdoor altijd een kopie
    }

    async storeLogboek()
    {
        const formData = new FormData();
        formData.append("spelend_data", JSON.stringify(this.logboek));
        if (this.hasField("title"))
        {
            formData.append("title", this.getField("title"));
        } else
        {
            formData.append("title", this.getField("naamloos"));
        }

        formData.append("app_user_id", window.app.user.id);
        formData.append("wachtwoord", window.app.user.password);

        formData.append("multiple_group_divisions", this.session_fields.multiple_group_divisions);
        formData.append("multiple_instructions", this.session_fields.multiple_instructions);
        formData.append("multiple_rounds", this.session_fields.multiple_rounds);
        formData.append("student_mode", this.session_fields.student_mode);
        formData.append("current_round", this.session_fields.current_round);
        formData.append("round_status", this.session_fields.round_status);


        const requestOptions = {
            method: 'POST',
            body: formData
        };

        await fetch("/store_spelend", requestOptions)
            .then(response => response.json())
            .then(login_json =>
            {
                if (login_json.status == "err")
                {
                    console.log("error");
                } else
                {
                    console.log("ok");
                }
            });
    }

    async loadLogboek(p_session_id)
    {
        const formData = new FormData();
        formData.append("app_user_id", window.app.user.id);
        formData.append("wachtwoord", window.app.user.password);
        formData.append("id", p_session_id);

        const requestOptions = {
            method: 'POST',
            body: formData
        };

        await fetch("/load_spelend", requestOptions)
            .then(response => response.json())
            .then(session_json =>
            {
                if (session_json.status == "err")
                {
                    alert("Problemen met laden, probeer het over vijf minuten opnieuw");
                } else
                {
                    window.app.activateSession(session_json.data.session);
                }
            });

    }

    async newLogboek()
    {
        const formData = new FormData();
        formData.append("app_user_id", window.app.user.id);
        formData.append("wachtwoord", window.app.user.password);

        const requestOptions = {
            method: 'POST',
            body: formData
        };

        await fetch("/new_spelend", requestOptions)
            .then(response => response.json())
            .then(session_json =>
            {
                console.log(session_json);
                if (session_json.status == "err")
                {
                    alert("Problemen met aanmaken, probeer het over vijf minuten opnieuw");
                } else
                {
                    window.app.activateSession(session_json.data.session);
                }
            });

    }
}
